import styled from '@emotion/styled'
import { InputLabel } from '@mui/material'

export const StyledInputLabel = styled(InputLabel)`
    font-size: ${({ theme }) => theme.fontSize.xsmall};
`
